var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfDownloadBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0438 1.34637V21.9627H0V5.80624L5.80543 0H20.7397C21.4548 0 22.0438 0.631113 22.0438 1.34637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4664 10.062V5.37585H10.1383V10.062H8.61523L11.3074 12.9155L14 10.062H12.4664Z",
    fill: "#969696"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30762 13.9789H17.7751V15.4722H4.30762V13.9789Z",
    fill: "#969696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67717 5.80624H0.133789L5.89715 0L5.85508 4.54401C5.89715 5.25927 5.35026 5.80624 4.67717 5.80624Z",
    fill: "#DADEDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1352 19.535V26.654C22.1352 27.3692 21.5462 28.0004 20.789 28.0004H1.3955C0.680341 28.0004 0.0493164 27.4113 0.0493164 26.654V19.535H22.1352Z",
    fill: "#DB4737"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.95809 22.609C7.95809 23.1686 7.73819 23.5882 7.37169 23.9379C7.00519 24.2177 6.41879 24.3576 5.68579 24.3576H5.09939V26.3859H4.14648V21.0004H5.83239C6.56539 21.0004 7.07849 21.1402 7.44499 21.42C7.81149 21.6998 7.95809 22.0495 7.95809 22.609ZM5.17269 23.6581H5.68579C6.12559 23.6581 6.49209 23.5882 6.71199 23.4483C6.93189 23.3084 7.07849 23.0287 7.07849 22.679C7.07849 22.3992 7.00519 22.1194 6.78529 21.9795C6.56539 21.8397 6.27219 21.7697 5.83239 21.7697H5.17269V23.6581ZM13.7488 23.6581C13.7488 24.5674 13.4556 25.2668 12.9425 25.6864C12.4294 26.176 11.6964 26.3859 10.6702 26.3859H9.05759V21.0004H10.8168C11.6964 21.0004 12.4294 21.2102 12.9425 21.6998C13.4556 22.1194 13.7488 22.8188 13.7488 23.6581ZM12.7226 23.6581C12.7226 22.3293 12.0629 21.6998 10.8168 21.6998H10.0105V25.6165H10.6702C12.0629 25.6864 12.7226 24.987 12.7226 23.6581ZM15.8745 26.3859H14.9216V21.0004H18.1468V21.7697H15.8745V23.4483H18.0002V24.2177H15.8745V26.3859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownloadBtn);
export default __webpack_public_path__ + "static/media/pdfDownloadBtn.dcaab9a9b65339197b1f73f5cf91fb27.svg";
export { ForwardRef as ReactComponent };